export interface ProductMappingModel {
	Active: boolean;
	BarcodeProductIsDiscontinued: boolean;
	BarcodeProductIsMensProduct: boolean;
	BarcodeProductIsNatureInspired: boolean;
	BarcodeProductMasterIsActive: boolean;
	BarcodeProductMasterIsDiscontinued: boolean;
	IsValidBarcode: boolean;
	IsVerifiedBarcode: boolean;
	ProductIsDiscontinued: boolean;
	ProductIsMensProduct: boolean;
	ProductIsNatureInspired: boolean;
	ProductMasterInconsistentWithBarcode: boolean;
	ProductMasterIsActive: boolean;
	ProductMasterIsDiscontinued: boolean;
	SourceCategoryIsExcluded: boolean;
	SourceCompanyIsExcluded: boolean;
	SourceMasterBrandIsExcluded: boolean;
	CreatedOn: Date;
	ModifiedOn: Date;
	ReviewedOn: Date;
	MetricQuantity: number;
	NonMetricQuantity: number;
	SourceSizeAsNumeric: number;
	BarcodeBrandId: number;
	BarcodeCategoryId: number;
	BarcodeCompanyId: number;
	BarcodeMappingModeId: number;
	BarcodeMasterBrandId: number;
	BarcodePackagingTypeId: number;
	BarcodeProductId: number;
	BarcodeProductMasterId: number;
	BarcodeSubBrandId: number;
	BarcodeSubcategoryFormId: number;
	BarcodeSubcategoryFunctionId: number;
	BrandId: number;
	CategoryId: number;
	CompanyId: number;
	CreatedByUserId: number;
	CreatedByUserRoleId: number;
	MappingAssignedToUserId: number;
	MappingAssignedToUserRoleId: number;
	MappingModeId: number;
	MasterBrandId: number;
	ModifiedByUserId: number;
	ModifiedByUserRoleId: number;
	PackagingTypeId: number;
	ProductBarcodeId: number;
	ProductId: number;
	ServiceAndProductMappingId: number;
	ProductMasterId: number;
	ProductSizeId: number;
	ReviewedByUserId: number;
	ReviewedByUserRoleId: number;
	SourceBarcodeMappingId: number;
	SourcePackagingTypeId: number;
	SourcePackagingTypeMappingId: number;
	SourceProductSizeMappingId: number;
	SubBrandId: number;
	SubcategoryFormId: number;
	SubcategoryFunctionId: number;
	BarcodeBrandName: string;
	BarcodeCategoryName: string;
	BarcodeCompanyName: string;
	BarcodeMappingModeName: string;
	BarcodeMasterBrandName: string;
	BarcodePackagingTypeName: string;
	BarcodeProductName: string;
	BarcodeProductSizeOnLabel: string;
	BarcodeSubBrandName: string;
	BarcodeSubcategoryFormName: string;
	BarcodeSubcategoryFunctionName: string;
	BrandName: string;
	CategoryName: string;
	CompanyName: string;
	CreatedByUserFullNameSortableOrPrincipalName: string;
	MappingAssignedToUserFullNameSortableOrPrincipalName: string;
	MappingModeKey: string;
	MappingModeName: string;
	MasterBrandName: string;
	MetricUnitOfMeasureName: string;
	MetricUnitOfMeasureSymbol: string;
	ModifiedByUserFullNameSortableOrPrincipalName: string;
	NonMetricUnitOfMeasureName: string;
	NonMetricUnitOfMeasureSymbol: string;
	PackagingTypeName: string;
	ProductName: string;
	ProductSizeOnLabel: string;
	QuantityTypeName: string;
	ReviewedByUserFullNameSortableOrPrincipalName: string;
	SourceBarcode: string;
	SourceBrand: string;
	SourceCategory: string;
	SourceCompany: string;
	SourceDescription: string;
	SourceMasterBrand: string;
	SourcePackagingType: string;
	SourcePackagingTypeName: string;
	SourceSize: string;
	SourceSubBrand: string;
	SourceSubcategory: string;
	SourceUnitOfMeasure: string;
	SubBrandName: string;
	SubcategoryFormName: string;
	SubcategoryFunctionName: string;
}

export interface ProductMappingGridDataReturnModel {
	data?: ProductMappingGridModel[];
	totalCount: number;
	summary?: number[];
	groupCount?: number;
}

export interface HeaderFilterData {
	text?: string;
	value?: any;
}

export interface ActionResultModel {
	State?: boolean;
	MoveToNextRow?: boolean;
	Data?: ProductMappingGridModel[];
}

export interface ProductMappingGridModel {
	Active: boolean;
	BarcodeMappingModeId: number;
	BarcodeMappingModeName: string;
	BarcodeProductMasterId: number;
	BrandId: number;
	BrandName: string;
	CategoryId: number;
	CategoryName: string;
	CompanyId: number;
	CompanyName: string;
	CreatedByUserFullNameSortableOrPrincipalName: string;
	CreatedByUserId: number;
	CreatedByUserRoleId: number;
	CreatedOn: Date;
	IsValidBarcode: boolean;
	IsVerifiedBarcode: boolean;
	MappingAssignedToUserFullNameSortableOrPrincipalName: string;
	MappingAssignedToUserId: number;
	MappingAssignedToUserRoleId: number;
	MappingModeId: number;
	MappingModeKey: string;
	MappingModeName: string;
	MappingPriority: number;
	MasterBrandId: number;
	MasterBrandName: string;
	MetricQuantity: number;
	MetricUnitOfMeasureName: string;
	MetricUnitOfMeasureSymbol: string;
	ModifiedByUserFullNameSortableOrPrincipalName: string;
	ModifiedByUserId: number;
	ModifiedByUserRoleId: number;
	ModifiedOn: Date;
	NonMetricQuantity: number;
	NonMetricUnitOfMeasureName: string;
	NonMetricUnitOfMeasureSymbol: string;
	PackagingTypeId: number;
	PackagingTypeName: string;
	ProductBarcodeId: number;
	ProductId: number;
	ProductIsDiscontinued: boolean;
	ProductIsMensProduct: boolean;
	ProductIsNatureInspired: boolean;
	ProductMasterId: number;
	ProductMasterInconsistentWithBarcode: boolean;
	ProductMasterIsActive: boolean;
	ProductMasterIsDiscontinued: boolean;
	ProductName: string;
	ProductSizeId: number;
	ProductSizeOnLabel: string;
	QuantityTypeName: string;
	ReviewedByUserFullNameSortableOrPrincipalName: string;
	ReviewedByUserId: number;
	ReviewedByUserRoleId: number;
	ReviewedOn: Date;
	ServiceAndProductMappingId: number;
	SourceBarcode: string;
	CleanBarcode: string;
	SourceBarcodeMappingId: number;
	SourceBrand: string;
	SourceCategory: string;
	SourceCategoryIsExcluded: boolean;
	SourceCompany: string;
	SourceCompanyIsExcluded: boolean;
	SourceDescription: string;
	SourceMasterBrand: string;
	SourceMasterBrandIsExcluded: boolean;
	SourcePackagingType: string;
	SourcePackagingTypeId: number;
	SourcePackagingTypeMappingId: number;
	SourcePackagingTypeName: string;
	SourceProductSizeMappingId: number;
	SourceSize: string;
	SourceSizeAsNumeric: number;
	SourceSubBrand: string;
	SourceSubcategory: string;
	SourceUnitOfMeasure: string;
	SubBrandId: number;
	SubBrandName: string;
	SubcategoryFormId: number;
	SubcategoryFormName: string;
	SubcategoryFunctionId: number;
	SubcategoryFunctionName: string;
}

export class ProductMappingToMasterGridResult {
	CurrentMappingModeId: number;
	MappingModeName: string;
	ServiceAndProductMappingId: number;
	BarcodeMappingId: number;
	BrandId: number;
	BrandName: string;
	CategoryId: number;
	CategoryName: string;
	CleanBarcode: string;
	CompanyId: number;
	CompanyName: string;
	CurrentProductMasterId: number;
	IsValidBarcode: boolean;
	IsVerifiedBarcode: boolean;
	MappingAsService: boolean;
	MappingModeId: number;
	MappingSource: string;
	MasterBrandId: number;
	MasterBrandName: string;
	PackagingTypeId: number;
	PackagingTypeName: string;
	ProductId: number;
	ProductIsDiscontinued: boolean;
	ProductIsMensProduct: boolean;
	ProductIsNatureInspired: boolean;
	ProductMasterId: number;
	ProductMasterIsActive: boolean;
	ProductMasterIsDiscontinued: boolean;
	ProductName: string;
	ProductSizeOnLabel: string;
	Ranking: number;
	SubBrandId: number;
	SubBrandName: string;
	SubcategoryFormId: number;
	SubcategoryFormName: string;
	SubcategoryFunctionId: number;
	SubcategoryFunctionName: string;
	ModifiedByUserId: number;
}

export interface UnifiedTransactionsForServiceAndProductMappingReturn {
	data?: UnifiedTransactionsForServiceAndProductMappingResult[];
	totalCount: number;
	summary?: number[];
	groupCount?: number;
}

export interface UnifiedTransactionsForServiceAndProductMappingResult {
	CurrencyAlphabeticCode: string;
	DataProviderName: string;
	Date: Date;
	Quantity: number;
	ReportName: string;
	Revenue: number;
	RowId: number;
	SourceSalonId: string;
}

export interface ProductMasterWithSizeListGridDataReturnModel {
	data?: ProductMasterWithSizeListGrid[];
	totalCount: number;
	summary?: number[];
	groupCount?: number;
}

export interface ProductMasterWithSizeListGrid {
	Active: boolean;
	BrandId: number;
	CompanyId: number;
	CreatedByUserId: number;
	CreatedByUserRoleId: number;
	MasterBrandId: number;
	ModifiedByUserRoleId: number;
	PackagingTypeId: number;
	ProductId: number;
	ReviewedByUserId: number;
	ReviewedByUserRoleId: number;
	SubBrandId: number;
	SubcategoryFormCategoryId: number;
	SubcategoryFormId: number;
	SubcategoryFormRelationIsActive: number;
	SubcategoryFunctionCategoryId: number;
	SubcategoryFunctionId: number;
	CategoryId: number;
	ProductSizeId: number;
	BrandIsActive: boolean;
	SubcategoryFormName: string;
	BrandName: string;
	BrandRelationIsActive: boolean;
	CompanyIsActive: boolean;
	CompanyName: string;
	CreatedByUserFullNameSortableOrPrincipalName: string;
	CreatedOn: Date;
	MasterBrandIsActive: boolean;
	MasterBrandName: string;
	MasterBrandRelationIsActive: boolean;
	ModifiedByUserFullNameSortableOrPrincipalName: string;
	ModifiedByUserId: string;
	PackagingTypeIsActive: boolean;
	PackagingTypeName: string;
	ProductIsActive: boolean;
	ProductIsDiscontinued: boolean;
	ProductIsMensProduct: boolean;
	ProductIsNatureInspired: boolean;
	ProductMasterId: number;
	ProductMasterIsActive: boolean;
	ProductMasterIsDiscontinued: boolean;
	ProductName: string;
	ProductRelationIsActive: boolean;
	ProductSizeOnLabel: string;
	ReviewedByUserFullNameSortableOrPrincipalName: string;
	SubBrandIsActive: boolean;
	SubBrandName: string;
	SubBrandRelationIsActive: boolean;
	SubcategoryFormCategoryIsActive: boolean;
	SubcategoryFormCategoryName: string;
	SubcategoryFormIsActive: boolean;
	SubcategoryFunctionCategoryIsActive: boolean;
	SubcategoryFunctionCategoryName: string;
	SubcategoryFunctionIsActive: boolean;
	SubcategoryFunctionName: string;
	SubcategoryFunctionRelationIsActive: boolean;
	BarcodeList: string;
	CategoryIsActive: boolean;
	CategoryName: string;
	ModifiedOn: Date;
	ProductSizeList: string;
	ReviewedOn: Date;
}

export interface ServiceMasterGridResult {
	Active: boolean;
	CreatedByUserFullNameSortableOrPrincipalName: string;
	CreatedByUserId: number;
	CreatedByUserRoleId: number;
	CreatedOn: Date;
	ModifiedByUserFullNameSortableOrPrincipalName: string;
	ModifiedByUserId: number;
	ModifiedByUserRoleId: number;
	ReviewedByUserFullNameSortableOrPrincipalName: string;
	ReviewedByUserId: number;
	ReviewedByUserRoleId: number;
	SegmentId: number;
	SegmentIsActive: boolean;
	SegmentName: string;
	SegmentRelationId: number;
	SegmentRelationIsActive: boolean;
	ServiceMasterId: number;
	ServiceTypeId: number;
	ServiceTypeIsActive: boolean;
	ServiceTypeName: string;
	SubSegmentId: number;
	SubSegmentIsActive: boolean;
	SubSegmentName: string;
	Definition: string;
	ModifiedOn: Date;
	RelatedTerms: string;
	ReviewedOn: Date;
}

export interface EditDropdownModel {
	Id: number;
	Name: string;
	IsNew?: boolean;
}

export interface ProductSizeGridModel {
	IsMetricPrefered?: boolean;
	MetricQuantity?: number;
	MetricUnitOfMeasureSymbol?: string;
	NonMetricQuantity?: number;
	NonMetricUnitOfMeasureSymbol?: string;
	ProductSizeByMetric?: string;
	ProductSizeByNonMetric?: string;
	ProductSizeId?: number;
	ProductSizeOnLabel?: string;
	QuantityTypeId?: number;
	QuantityTypeKey?: string;
	QuantityTypeName?: string;
	IsNew?: boolean;
}

export interface AffectingCompanyData {
	Id: number;
	Name: string;
}

export interface AffectingMasterBrandData {
	MasterBrandRelationId: number;
	CompanyName: string;
	MasterBrandName: string;
}

export interface AffectingBrandData {
	BrandRelationId: number;
	CompanyName: string;
	MasterBrandName: string;
	BrandName: string;
}

export interface AffectingSubBrandData {
	SubBrandRelationId: number;
	CompanyName: string;
	MasterBrandName: string;
	BrandName: string;
	SubBrandName: string;
}

export interface AffectingProductData {
	ProductRelationId: number;
	CompanyName: string;
	MasterBrandName: string;
	BrandName: string;
	SubBrandName: string;
	ProductName: string;
}

export interface RenameDataModel {
	Id?: number;
	NewName?: string;
	ModifiedByUserId?: number;
}

export interface ProductMasterDataModel {
	BrandName?: string;
	CategoryId?: number;
	CompanyName?: string;
	MasterBrandName?: string;
	MensProduct?: boolean;
	NatureInspired?: boolean;
	ProductMasterId?: number;
	ProductName?: string;
	ProductSizeIdList?: string;
	SubBrandName?: string;
	SubcategoryFormId?: number;
	SubcategoryFunctionId?: number;
	TransactionLevel?: number;
	UserId?: number;
}
